"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function tern(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M6.30263 16.3238L5.43113 15.8176V8.18331L6.83513 7.36731L7.70663 7.87281L6.30263 8.68956V11.3431L9.85313 13.4071V14.3888L6.30263 12.3256V16.3231V16.3238ZM18.5689 14.8051V15.8176L12.0004 19.6351L10.5964 18.8183V17.8058L12.0004 18.6218L14.2841 17.2951V13.1686L15.1286 12.6773V16.8046L18.5689 14.8051ZM20.2436 12.0001V11.8276L16.8536 13.7986V12.8161L20.2436 10.8458V7.20981L11.9989 2.41956L7.87763 4.81506L7.72913 4.90131L11.1191 6.87156L10.2746 7.36206L6.88463 5.39181L3.75638 7.20981V16.7903L7.87763 19.1858L8.02688 19.2721V15.3316L8.87138 15.8221V19.7633L12.0004 21.5806L20.2436 16.7903V12.0001ZM15.9724 10.1821L12.5599 12.1666V16.2931L12.0004 16.6178L11.5781 16.3726V12.4051L8.02688 10.3411V9.69156L8.44913 9.44556L11.8631 11.4293L15.4144 9.36681L15.9731 9.69156V10.1828L15.9724 10.1821ZM11.1289 4.87206L11.9996 4.36656L18.5681 8.18406V9.81531L17.6981 10.3208V8.68881L15.4129 7.36206L11.8624 9.42531L11.0171 8.93481L14.5684 6.87081L11.1289 4.87206Z", fill: color }));
}
exports["default"] = tern;
//# sourceMappingURL=tern.js.map